import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '../forms/forms.module';
import { TranslateModule } from '@ngx-translate/core';
import { AddressCompletionOptions } from './interfaces/address-completion-options.interface';
import { AddressCompletionComponent } from './components/address-completion/address-completion.component';
import { ADDRESS_COMPLETION_OPTIONS } from './address-completion.token';
import { AddressCompletionService } from './services/address-completion.service';

@NgModule({
  declarations: [AddressCompletionComponent],
  imports: [FormsModule, CommonModule, TranslateModule],
  exports: [AddressCompletionComponent],
})
export class AddressCompletionModule {
  static forRoot(options: AddressCompletionOptions) {
    return {
      ngModule: AddressCompletionModule,
      providers: [
        AddressCompletionService,
        {
          provide: ADDRESS_COMPLETION_OPTIONS,
          useValue: options,
        },
      ],
    };
  }
}
